import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  production: boolean;
  recipeImagePath: string;
  getRecipeList: string;
  cookieDomain: string;
  getSiteData: string;
  getNewToken: string;
  login?: string;
  logout?: string;
  maintainence: string;
  googleApiKey?: string;
}

/**
 * Injection token for environment configuration.
 * Apps can extend EnvironmentConfig interface with additional properties.
 *
 * Usage:
 * 1. Extend EnvironmentConfig in your app (e.g., apps/recipes/src/environments/environment.interface.ts):
 *    export interface Environment extends EnvironmentConfig { customProp: string; }
 * 2. Provide in app.config.ts: { provide: ENV_CONFIG, useValue: environment }
 * 3. Inject: private readonly env = inject(ENV_CONFIG)
 */

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>(
  'Environment Configuration',
);
